import { gql } from "@/__generated__/gql";

export const RISE_APPLY_SCORE_TIME_SERIES = gql(`
  query riseApplyScoreTimeSeries($orgId: ID!, $userId: ID!) {
    node(id: $userId) {
      id
      ... on Student {
        __typename
        rise {
          applyScoreTimeSeries(organizationId: $orgId) {
            date
            value
            index
          }
        }
      }
    }
  }
`);
